import { Component, AfterViewInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-point-style',
  template: '<canvas #canvas width="30" height="30"></canvas>',
  styles: `:host {
    display: inline-block;
    width: 30px;  /* Breite des Canvas */
    height: 30px; /* Höhe des Canvas */
  }
  
  canvas {
    display: inline-block; /* Sicherstellen, dass auch das Canvas inline ist */
  }`,
})
export class PointStyleComponent implements AfterViewInit {
  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLCanvasElement>;
  @Input() side: 'links' | 'rechts' = 'links';

  ngAfterViewInit(): void {
    this.drawCircle();
  }

  drawCircle(): void {
    const ctx = this.canvas.nativeElement.getContext('2d');
    if (ctx) {
      const centerX = this.canvas.nativeElement.width / 2;
      const centerY = this.canvas.nativeElement.height / 2;
      const radius = 10;

      if (this.side === 'links') {
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius - 1, 0, 2 * Math.PI, false);
        ctx.fillStyle = 'rgba(200, 200, 255, 1)';
        ctx.fill();

        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(0, 0, 255, 1)';
        ctx.stroke();

        ctx.closePath();

        ctx.font = '10px sans-serif';
        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('L', centerX, centerY);
      } else {
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius - 1, 0, 2 * Math.PI, false);
        ctx.fillStyle = 'rgba(255, 200, 200, 1)';
        ctx.fill();

        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(255, 0, 0, 1)';
        ctx.stroke();

        ctx.closePath();

        ctx.font = '10px sans-serif';
        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('R', centerX, centerY);
      }
    }
  }
}
